<template>
  <div>
    <mdb-btn @click="$emit('finished')" icon="arrow-left">Back to Console</mdb-btn>
    <mdb-btn @click="loadDetails" icon="recycle">Refresh</mdb-btn>
    <div v-if="details">
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Upcoming Jitsi Events (24 hours)</h4>
          <h5>{{details.timezone}}</h5>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl striped responsive>
            <mdb-tbl-head>
              <tr>
                <th>ID</th>
                <th>Start</th>
                <th>Title</th>
                <th>Group</th>
                <th>Participants</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="e in details.events" :key="e.id">
                <td>{{e.id}}</td>
                <td>{{e.startDate}}</td>
                <td>{{e.title}}</td>
                <td>{{e.groupName}}</td>
                <td>{{e.participants}}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Meet Server</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl striped responsive>
            <mdb-tbl-head>
              <tr>
                <th>Name</th>
                <th>Instance</th>
                <th>Public IP</th>
                <th>Type</th>
                <th>Image</th>
                <th>State</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="i in details.meetServers" :key="i.instanceId">
                <td>{{i.name}}</td>
                <td>{{i.instanceId}}</td>
                <td>{{i.publicIpAddress}}</td>
                <td>{{i.instanceType}}</td>
                <td>{{i.imageId}}</td>
                <td>{{i.state}}</td>
                <th>
                  <mdb-btn v-if="i.state=='stopped'" size="sm" rounded color="success" @click="startInstance(i)" icon="play">Start</mdb-btn>
                  <mdb-btn v-if="i.state=='running'" size="sm" rounded color="danger" @click="stopInstance(i)" icon="stop">Stop</mdb-btn>
                </th>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
          <div><span class="h5">Current Active Conferences: </span> {{ details.activeConferences}}</div>
          <div><span class="h5">Current Active Participants: </span> {{ details.activeParticipants}}</div>
          <div class="text-info"><mdb-icon icon="clock"/><i> Status current as of {{ details.statusAsOf}}</i> </div>

        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Additional Video Bridge Capacity</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl striped responsive>
            <mdb-tbl-head>
              <tr>
                <th>Name</th>
                <th>Instance</th>
                <th>Public IP</th>
                <th>Type</th>
                <th>Image</th>
                <th>State</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="i in details.videoBridges" :key="i.instanceId">
                <td>{{i.name}}</td>
                <td>{{i.instanceId}}</td>
                <td>{{i.publicIpAddress}}</td>
                <td>{{i.instanceType}}</td>
                <td>{{i.imageId}}</td>
                <td>{{i.state}}</td>
                <th>
                  <mdb-btn v-if="i.state=='stopped'" size="sm" rounded color="success" @click="startInstance(i)" icon="play">Start</mdb-btn>
                  <mdb-btn v-if="i.state=='running'" size="sm" rounded color="danger" @click="stopInstance(i)" icon="stop">Stop</mdb-btn>
                </th>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
          <div>
            <span class="h5">Auto Start/Stop Enabled: </span> {{ details.autoScale}}
            <mdb-btn size="sm" rounded @click="toggleAutoScale">Toggle</mdb-btn>

          </div>
        </mdb-card-body>

      </mdb-card>
    </div>

  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "admin-aws-jitsi",
  display: "Jitsi",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbIcon,
    mdbCardBody,
    mdbCardFooter,
    mdbTbl,
    mdbTblBody,
    mdbTblHead
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  async mounted() {
    this.loadDetails()
  },
  data() {
    return {
      details: null
    }
  },
  methods: {
    toggleAutoScale() {
      this.$store.dispatch("setExecuting", true)
      api.get("/aws/jitsiToggleScale/").then(
        (results) => {
          this.details.autoScale = results.data.autoScale
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    loadDetails() {
      this.$store.dispatch("setExecuting", true)
      api.get("/aws/jitsiDetails/").then(
        (results) => {
          this.details = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    startInstance(instance) {
      this.$store.dispatch("setExecuting", true)
      api.post("/aws/startInstance", instance).then(
        (details) => {
          instance.state = "pending"
          this.$notify.success({message: details.data, timeOut: 7000})
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    stopInstance(instance) {
      this.$store.dispatch("setExecuting", true)
      api.post("/aws/stopInstance", instance).then(
        (details) => {
          instance.state = "stopping"
          this.$notify.success({message: details.data, timeOut: 7000})
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }

}
;
</script>
